import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";

import { MedIconMentionComponent } from "./med-icon-mention.component";

@NgModule({
  declarations: [
    MedIconMentionComponent,
  ],
  imports: [
    CommonModule,
  ],
  exports: [
    MedIconMentionComponent,
  ],
})
export class MedIconMentionModule { }
